module.exports = __webpack_public_path__ + "img/Wp_2025.fb9d59de.png";